import { gql } from '@apollo/client';

export const CREATE_ROLE_MUTATOR = gql`
  mutation createRoleMutator($role: JSON) {
    createRole(role: $role)
  }
`;

export const UPDATE_ROLE_MUTATOR = gql`
  mutation updateRoleMutator($updated_role: JSON) {
    updateRole(updated_role: $updated_role)
  }
`;

export const DELETE_ROLE_MUTATOR = gql`
  mutation deleteRoleMutator($role_id: JSON) {
    deleteRole(role_id: $role_id)
  }
`;
